
export default {
  name: 'ConfigureTimeClockSettingsSvg',
};
